(function () {
  var API_URL = 'https://lipsel.com:3215/notify/subscribe';

  function openModal(modal, scrollY) {
    modal._scrollY = scrollY != null ? scrollY : window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + modal._scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    modal.hidden = false;
  }

  function closeModal(modal) {
    var scrollY = modal._scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    modal.hidden = true;
    window.scrollTo(0, scrollY);
  }

  function resetModal(modal) {
    var formWrap = modal.querySelector('.back-in-stock__form');
    var success = modal.querySelector('.back-in-stock__success');
    var error = modal.querySelector('.back-in-stock__error');
    if (formWrap) { formWrap.hidden = false; var inp = formWrap.querySelector('input[type=email]'); if (inp) inp.value = ''; }
    if (success) success.hidden = true;
    if (error) error.hidden = true;
  }

  function initWrap(wrap) {
    if (wrap._bisInit) return;
    wrap._bisInit = true;

    // Move modal to body to escape any stacking context
    var wrapper = wrap.closest('.bis-wrapper');
    if (!wrapper) return;
    var modal = wrapper.querySelector('.back-in-stock-modal');
    if (!modal) return;
    document.body.appendChild(modal);
    wrap._bisModal = modal;

    wrap.querySelector('.back-in-stock__trigger').addEventListener('click', function () {
      // Sync variant id to modal
      modal.dataset.variantId = wrap.dataset.variantId;
      modal.dataset.productId = wrap.dataset.productId;
      modal.dataset.shop = wrap.dataset.shop;
      modal.dataset.locale = wrap.dataset.locale;
      resetModal(modal);
      openModal(modal);
    });

    modal.querySelector('.back-in-stock-modal__close').addEventListener('click', function () {
      closeModal(modal);
    });

    modal.querySelector('.back-in-stock-modal__backdrop').addEventListener('click', function () {
      closeModal(modal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
    });

    var emailInput = modal.querySelector('input[type=email]');
    var formWrap = modal.querySelector('.back-in-stock__form');

    modal.querySelector('.back-in-stock__submit').addEventListener('click', function () {
      if (!emailInput.reportValidity()) return;

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: emailInput.value,
          variant_id: modal.dataset.variantId,
          product_id: modal.dataset.productId,
          shop_domain: modal.dataset.shop,
          locale: modal.dataset.locale,
        }),
      })
        .then(function (res) {
          formWrap.hidden = true;
          modal.querySelector(res.ok ? '.back-in-stock__success' : '.back-in-stock__error').hidden = false;
        })
        .catch(function () {
          modal.querySelector('.back-in-stock__error').hidden = false;
        });
    });
  }

  function updateWrap(wrap, variant) {
    // Storefront variant JSON has NO inventory_quantity (theme keeps qty in a
    // separate map), so the old `inventory_quantity <= 0` check was always false
    // on variant switch → button vanished on multi-variant products. `available`
    // is reliable: false == sold out for tracked/deny variants.
    var soldOut = variant && variant.available === false;

    wrap.classList.toggle('back-in-stock--hidden', !soldOut);
    if (variant) wrap.dataset.variantId = variant.id;

    var modal = wrap._bisModal;
    if (modal && !modal.hidden) closeModal(modal);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.back-in-stock').forEach(initWrap);

    document.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      document.querySelectorAll('.back-in-stock').forEach(function (wrap) {
        updateWrap(wrap, variant);
      });
    });
  });
})();
